import { SCHEDULING_RELEASE_PUBLISH_SHIFT, RELEASE_AGENCY_SHIFT } from 'constants/endpoints';
import { METHOD_PATCH, METHOD_POST } from 'requests';
import { ApiRequestConfigType, ReleaseWithTimeOffPayloadType } from 'requests/index.types';
import { SessionService } from 'services';

export const API_POST_releasePublishedShifts = (params: {
  reason_message: string;
  reason_category: string;
  shift_id: number;
  time_off?: ReleaseWithTimeOffPayloadType;
}): ApiRequestConfigType => {
  const { reason_message = '', reason_category = '', shift_id, time_off } = params;

  const message = reason_category === 'other' ? reason_message : time_off?.title ?? null;

  const body: {
    release: {
      reason_message: string | null;
      reason_category: string;
    };
    time_off?: ReleaseWithTimeOffPayloadType;
  } = {
    release: {
      reason_message: message,
      reason_category,
    },
  };

  if (time_off) {
    body.time_off = time_off;
  }

  return SessionService.assertUserType('Agency')
    ? {
        __typename: 'LegacyAPI',
        url: RELEASE_AGENCY_SHIFT(shift_id),
        method: METHOD_PATCH,
        body,
      }
    : {
        __typename: 'LegacyAPI',
        url: SCHEDULING_RELEASE_PUBLISH_SHIFT(shift_id),
        method: METHOD_POST,
        body,
      };
};
